import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-permit-washers',
    templateUrl: './permit-washers.component.html',
    styleUrls: ['./permit-washers.component.scss'],
})
export class PermitWashersComponent {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';
}
